import {
    Box,
    Card,
    CardContent,
    Grid,
    Toolbar,
    Typography,
    MenuItem,
    Select,
    FormHelperText,
    TextField,
    Collapse
} from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo } from "react";
import { ReactComponent as TooltipIcon } from "../../../../assets/images/tooltip.svg";
import emty from "../../../../assets/images/emty.png";
import { makeStyles, styled } from "@mui/styles";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Icon from '@mui/material/Icon';
import { ReactComponent as KpiArrow } from "../../../../assets/images/arrow-down.svg";
import { ReactComponent as AchievementEvaluation } from "../../../../assets/images/achievementEvaluation.svg";
import { ReactComponent as FeedbackEvaluation } from "../../../../assets/images/feedback.svg";
import ViewFeedback from "../../../../assets/images/viewFeedback.svg";
import RequestFeedback from "../../../../assets/images/requestFeedback.svg";
import * as Util from "../../../../services/global.service";
import Rating from '@mui/material/Rating';
import DialogAchievements from "../../../../components/kpi/DialogAchievements";
import DialogGoal from "../../../../components/kpi/DialogGoal";
import DialogViewFeedback from "../../../../components/kpi/DialogViewFeedback";
import DialogCompetency from "../../../../components/kpi/DialogCompetency";
import DialogRequest from "../../../../components/kpi/DialogRequest";
import evaluateService from "../../../../services/evaluate.service";
import redBg from "../../../../assets/images/red.svg";
import greenBg from "../../../../assets/images/green.svg";
import SimpleDialog from "../../../../components/SimpleDialog";

const styles = {
    path: {
        color: "#68717A",
    },
    paDatasEvaluation: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        backgroundColor: "#fff",
        height: "220px",
        boxShadow: "0px 0px 5px rgb(0 0 0 / 10%)",
        borderRadius: "10px",
        "justify-content": "center",
        "align-items": "center",
        marginBottom: "30px"
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    },
};

const SeeAllCompetency = (props) => {
    const { t } = useTranslation();
    let { rs, loRow, statusEdit, callBack, editor, actSave, formID, checkeNextAction, have_manager_evaluation, have_self_evaluation, have_feedback_competency, have_feedback_goal, dataEmpolyee, dataEmpolyeeOwner } = props
    const useStyles = makeStyles({
        iconContainer: {
            width: 48,
            height: 48,
            borderRadius: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        profileContainer: {
            width: 70,
            height: 70,
            borderRadius: "50%",
            marginTop: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        containerAchievements: {
            background: "#FAFAFA",
            border: "1px solid #DADADA",
            borderRadius: "4px",
            maxWidth: "300px",
            width: "100%"
        },
        statusBadge: {
            maxWidth: "130px",
            borderRadius: "5px",
            padding: "5px 12px",
            margin: "0",
            background: ""
        },
        fillBlack: {
            '& > path': {
                fill: '#404349'
            },
            '& g > path': {
                fill: '#404349'
            },
        },
    })
    const classes = useStyles();
    const [openAchievements, setOpenAchievements] = React.useState(false);
    const [dataAchievements, setDataAchievements] = React.useState("");
    const [dataGoal, setDataGoal] = React.useState({});
    const [iconGoal, setIconGoal] = React.useState("");
    const [btnGoal, setBtnGoal] = React.useState("");
    const [colorGoal, setColorGoal] = React.useState("");
    const [openGoal, setOpenGoal] = React.useState(false);
    const [openViewFeedback, setOpenViewFeedback] = React.useState(false);
    const [dataViewFeedback, setDataViewFeedback] = React.useState({});
    const [nameGoal, setNameGoal] = React.useState("");
    const [descriptionGoal, setDescriptionGoal] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [valueSerial, setValueSerial] = React.useState('');
    const [openCompetency, setOpenCompetency] = React.useState(false);
    const [nameCompetency, setNameCompetency] = React.useState("");
    const [proficiencyCompetency, setProficiencyCompetency] = React.useState({});
    const [descriptionCompetency, setDescriptionCompetency] = React.useState("");
    const [type, setType] = React.useState("");
    const [typeRequest, setTypeRequest] = React.useState("");
    const [dataGoalRequest, setDataGoalRequest] = React.useState({});
    const [dataCompetencyRequest, setDataCompetencyRequest] = React.useState({});
    const [refID, setRefID] = React.useState("");
    const [scale, setScaleCompetency] = React.useState({});
    const [data, setData] = React.useState({});
    const [dataSave, setDataSave] = React.useState([]);
    const [valueSerialFeedback, setValueSerialFeedback] = React.useState('');
    const [openRequest, setOpenRequest] = React.useState(false);
    const [isSuccessRequest, openSuccessRequest] = React.useState(false);
    const onOpenAchievements = (type, serial, form_id) => {
        evaluateService.getEvaluationAchievements(type, serial, form_id).then(
            (response) => {
                if (response.data.achievement_support !== undefined && response.data.achievement_support.length > 0) {
                    setDataAchievements(response.data.achievement_support)
                }
                setOpenAchievements(true)
                setType(type)
            },
        );
    }
    const onOpenGoal = (name, description, goal_group, goal_subgroup, metricDescription, target_value, alignment_type, linked, type, measurement, more_detail) => {
        setOpenGoal(true)
        setDataGoal({
            name: name,
            description: description,
            goal_group: goal_group,
            goal_subgroup: goal_subgroup,
            metricDescription: metricDescription,
            target_value: target_value,
            alignment_type: alignment_type,
            linked: linked,
            type: type,
            measurement: measurement,
            more_detail: more_detail || []
        })
    }
    let checkDataRating = (val) => {
        let data = Number(val)
        if (data < 0.5 || isNaN(data)) {
            return 0
        } else if (data < 1) {
            return 0.5
        } else if (data < 1.5) {
            return 1
        } else if (data < 2) {
            return 1.5
        } else if (data < 2.5) {
            return 2
        } else if (data < 3) {
            return 2.5
        } else if (data < 3.5) {
            return 3
        } else if (data < 4) {
            return 3.5
        } else if (data < 4.5) {
            return 4
        } else if (data < 5) {
            return 4.5
        } else if (data < 5.5) {
            return 5
        } else if (data < 6) {
            return 5.5
        } else if (data < 6.5) {
            return 6
        } else if (data < 7) {
            return 6.5
        } else if (data < 7.5) {
            return 7
        } else if (data < 8) {
            return 7.5
        } else if (data < 8.5) {
            return 8
        } else if (data < 9) {
            return 8.5
        } else if (data < 9.5) {
            return 9
        } else if (data < 10) {
            return 9.5
        } else if (data < 10.5) {
            return 10
        } else if (data < 11) {
            return 10.5
        } else if (data < 11.5) {
            return 11
        } else if (data < 12) {
            return 11.5
        } else if (data < 12.5) {
            return 12
        } else if (data < 13) {
            return 12.5
        } else if (data < 13.5) {
            return 13
        } else if (data < 14) {
            return 13.5
        } else if (data < 14.5) {
            return 14
        } else if (data < 15) {
            return 14.5
        } else if (data < 15.5) {
            return 15
        } else if (data < 16) {
            return 15.5
        } else if (data < 16.5) {
            return 16
        } else if (data < 17) {
            return 16.5
        } else if (data < 17.5) {
            return 17
        } else if (data < 18) {
            return 17.5
        } else if (data < 18.5) {
            return 18
        } else if (data < 19) {
            return 18.5
        } else if (data < 19.5) {
            return 19
        } else if (data < 20) {
            return 19.5
        } else if (data >= 20) {
            return 20
        }
    }
    const handleChangeRating = async (event, order, key, subkey, serial, behavioralSerial, id, type) => {
        let dt = JSON.parse(JSON.stringify(data))
        let dtSave = JSON.parse(JSON.stringify(dataSave))
        if (Util.formatData(dt[key][order]?.evaluate_rating[subkey]?.rating, false) === false) {
            dt[key][order].evaluate_rating[subkey].rating = { serial: event.target.value }
        } else {
            dt[key][order].evaluate_rating[subkey].rating.serial = event.target.value
        }
        if (type === "behavioral") {
            if (Util.formatData(dt?.competency_items[order]?.competency_behavioral[id]?.evaluate_rating[subkey]?.rating?.serial, false) === false) {
                dt.competency_items[order].competency_behavioral[id].evaluate_rating[subkey].rating = { serial: event.target.value }
            } else {
                dt.competency_items[order].competency_behavioral[id].evaluate_rating[subkey].rating.serial = event.target.value
            }
        }
        let findData = dtSave.filter((res) => res?.serial === serial)
        if (findData.length > 0) {
            for (let index = 0; index <= dtSave.length - 1; index++) {
                if (dtSave[index]?.serial === serial) {
                    if (type === "behavioral") {
                        if (Util.formatData(dtSave[index]?.behavioral, false) !== false) {
                            let findDataBehavioral = dtSave[index].behavioral.filter((res) => res?.serial === behavioralSerial)
                            if (findDataBehavioral.length > 0) {
                                for (let idex = 0; idex <= dtSave[index].behavioral.length - 1; idex++) {
                                    if (dtSave[index].behavioral[idex]?.serial === behavioralSerial) {
                                        dtSave[index].behavioral[idex].rating.serial = event.target.value
                                    }
                                }
                            } else {
                                dtSave[index].behavioral.push({
                                    "serial": behavioralSerial,
                                    "rating": {
                                        "serial": event.target.value,
                                        "type": "behavioral"
                                    },
                                    "comment": "",
                                    "ref_id": Util.formatData(loRow?.ref_template_id, "")
                                })
                            }
                        } else {
                            dtSave[index].behavioral = [{
                                "serial": behavioralSerial,
                                "rating": {
                                    "serial": event.target.value,
                                    "type": "behavioral"
                                },
                                "comment": "",
                                "ref_id": Util.formatData(loRow?.ref_template_id, "")
                            }]
                        }
                    } else {
                        dtSave[index].rating.serial = event.target.value
                    }
                }
            }
        } else {
            if (type === "behavioral") {
                dtSave.push({
                    "serial": serial,
                    "rating": {},
                    "behavioral": [{
                        "serial": behavioralSerial,
                        "rating": {
                            "serial": event.target.value,
                            "type": "behavioral"
                        },
                        "comment": ""
                    }],
                    "comment": Util.formatData(dt[key][order]?.evaluate_rating[subkey]?.comment, false) !== false ? dt[key][order].evaluate_rating[subkey].comment : "",
                    "ref_id": Util.formatData(loRow?.ref_template_id, "")
                })
            } else {
                dtSave.push({
                    "serial": serial,
                    "rating": {
                        "serial": event.target.value,
                        "type": key === "goal_items" ? "goal" : key === "competency_items" ? "competency" : key === "custom_template_item" ? "custom" : ""
                    },
                    "comment": Util.formatData(dt[key][order]?.evaluate_rating[subkey]?.comment, false) !== false ? dt[key][order].evaluate_rating[subkey].comment : "",
                    "ref_id": Util.formatData(loRow?.ref_template_id, "")
                })
            }
        }
        await setDataSave(dtSave)
        setData(dt)
    };

    const handleChangeComment = async (event, order, key, subkey, serial) => {
        let dt = JSON.parse(JSON.stringify(data))
        let dtSave = JSON.parse(JSON.stringify(dataSave))
        dt[key][order].evaluate_rating[subkey].comment = event.target.value
        let findData = dtSave.filter((res) => res?.serial === serial)
        if (findData.length > 0) {
            for (let index = 0; index <= dtSave.length - 1; index++) {
                if (dtSave[index]?.serial === serial) {
                    dtSave[index].comment = event.target.value
                }
            }
        } else {
            dtSave.push({
                "serial": serial,
                "rating": Util.formatData(dt[key][order]?.evaluate_rating[subkey]?.rating, false) !== false ? dt[key][order].evaluate_rating[subkey].rating : {
                    "serial": "",
                    "type": key === "goal_items" ? "goal" : key === "competency_items" ? "competency" : key === "custom_template_item" ? "custom" : ""
                },
                "comment": event.target.value,
                "ref_id": Util.formatData(loRow?.ref_template_id, "")
            })
        }
        setDataSave(dtSave)
        setData(dt)
    };
    const onOpenCompetency = (name, proficiency, description, scale) => {
        setOpenCompetency(true)
        setNameCompetency(name)
        setProficiencyCompetency(proficiency)
        setDescriptionCompetency(description)
        setScaleCompetency(scale)
    }
    const handleTooltipOpen = (data, type) => {
        if (data !== valueSerial) {
            setOpen(true)
            setValueSerial(data)
            // setValueType(type)
        } else {
            setOpen(false)
            setValueSerial("")
            // setValueType("")
        }
    };
    const onCloseGoal = () => {
        setOpenGoal(false)
        setIconGoal("")
        setBtnGoal("")
        setColorGoal("")
    }
    const onCloseAchievements = () => {
        setOpenAchievements(false)
        setDataAchievements("")
    }
    const onCloseCompetency = () => {
        setOpenCompetency(false)
        setNameCompetency("")
        setProficiencyCompetency("")
        setDescriptionCompetency("")
        setScaleCompetency("")
    }

    useEffect(() => {
        callBack(dataSave, loRow?.type)
    }, [dataSave]);
    useEffect(() => {
        setData(rs)
    }, [rs]);
    useEffect(() => {
        let maybeHandler = (event) => {
            if (event.target.closest(".tooltip") === null) {
                setOpen(false)
                setValueSerial("")
            }
        };

        document.addEventListener("click", maybeHandler);

        return () => {
            document.removeEventListener("click", maybeHandler);
        };
    });
    const StyledRatingEva = styled(Rating)({
        '& .MuiRating-icon': {
            color: "#404349 !important"
        },
    });
    const RatingEvaluation = styled(Rating)({
        // '& .MuiRating-icon': {
        //     color: "#C4C4C4 !important"
        // },
    });
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
            fontSize: "14px"
        },
    }));
    let showGap = (dataGap) => {
        let gap = Number(dataGap)
        if (isNaN(gap) === false) {
            return gap;
        }
        return false;
    }

    let getName = (data) => {
        let dataMain = data.toLowerCase()
        let index = dataMain.search("<br")
        if (Util.formatData(data, false) !== false) {
            if (index >= 0) {
                return data.substr(0, index)
            } else {
                return data
            }
        }
        return ""
    }

    let sunBehavioral = (data, editor) => {
        let alldata = true
        let sumVal = 0
        let getLength = Util.formatData(data, []).length
        for (let index = 0; index <= data.length - 1; index++) {
            if (Util.formatData(data[index]?.evaluate_rating[editor]?.rating?.serial, false) !== false) {
                let filterData = Util.formatData(data[index]?.behavioral_scale, []).filter((rs) => data[index]?.evaluate_rating[editor]?.rating?.serial === rs.serial)
                if (filterData.length > 0) {
                    sumVal = sumVal + Number(Util.formatData(filterData[0]?.value, 0))
                }
            } else {
                alldata = false
            }
        }
        if (alldata) {
            return (sumVal / getLength).toFixed(1)
        } else {
            return 0
        }
    }

    const displayCollapse = (data) => {
        if (data !== valueSerialFeedback) {
            setValueSerialFeedback(data)
        } else {
            setValueSerialFeedback("")
        }
    }

    const closeViewFeedback = () => {
        setOpenViewFeedback(false)
        setDataViewFeedback({})
    }
    const onOpenRequest = (typeRequest, type, serial, form_id, name, description) => {
        setType(type)
        setDataGoalRequest({
            name: name,
            description: description,
        })
        setDataCompetencyRequest({
            name: name,
            description: description,
        })
        setRefID(serial)
        setTypeRequest(typeRequest)
        setOpenRequest(true)
    }
    const onCloseRequest = () => {
        setOpenRequest(false)
    }
    let onCloseRequestSuccess = () => {
        openSuccessRequest(true)
    }

    let closeRequestSuccess = () => {
        openSuccessRequest(false)
        callBack(dataSave, loRow?.type)
    }

    const openFeedback = async (data, type, name, description, formID, dataOpenRequest) => {
        let datas = { type: type, serial: data, name: name, description: description, formID: formID, dataOpenRequest: dataOpenRequest }
        await setDataViewFeedback(datas)
        setOpenViewFeedback(true)
    }

    let openDialogRequest = () => {
        setOpenViewFeedback(false)
        onOpenRequest(dataViewFeedback?.dataOpenRequest?.emp, dataViewFeedback?.dataOpenRequest?.type, dataViewFeedback?.dataOpenRequest?.serial, dataViewFeedback?.dataOpenRequest?.formID, dataViewFeedback?.dataOpenRequest?.name, dataViewFeedback?.dataOpenRequest?.description)
        setDataViewFeedback({})
    }
    return (
        <Box>
            <Box item xs={12}>
                <Toolbar color="primary" sx={{ backgroundColor: Util.formatData(data?.options?.color, data?.color) }} style={{ borderRadius: "5px" }}>
                    <Box sx={{ "align-items": "center", display: "flex", "flex-direction": "row" }}>
                        <Box sx={{ width: "50px", "align-items": "center", display: "flex", "flex-direction": "row" }}>
                            <Icon sx={{ color: "#ffffff", "font-size": "30px" }}>{Util.formatData(data?.options?.icon, data?.icon)}</Icon>
                        </Box>
                        <Typography variant="h4_hilight" color="#FFF" fontSize={24} fontWeight={600} sx={{ "text-transform": "capitalize" }}>
                            {data?.name}
                        </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ padding: "6px 16px", borderRadius: "4px", "minWidth": "64px", border: "1px solid #fff", textAlign: "center" }} color="#FFF" variant="toolbar" fontSize={24} fontWeight={600}>
                        <Typography color="#FFF" fontSize={18} fontWeight={600}>
                            {Util.formatData(data?.weight, "0")}%
                        </Typography>
                    </Box>
                </Toolbar>
                {data?.name !== undefined && data?.name !== "" ?
                    <Box mt={2.5} mb={2.5} sx={{ display: "flex", "flex-direction": "row", "justify-content": "space-between" }}>
                        <Typography fontSize={18} fontWeight={400} variant="label" color="#A3A3A3" sx={{ "text-transform": "capitalize" }}>
                            {data?.name}: <span style={{ color: "#5DA196" }}>{Util.formatData(data?.total, "0")}</span>  {loRow?.type === "goal" ? t('evaluation.unitGoals') : loRow.type === "competency" ? t('evaluation.unitCompetencies') : t('evaluation.item')}
                        </Typography>
                    </Box>
                    : null
                }
            </Box>
            {Util.formatData(data?.custom_template_item, false) !== false && data?.custom_template_item.length > 0 ?
                <Grid item xs={12} >
                    {data?.custom_template_item.map((item, order) => (
                        <Card sx={{ height: 1, marginBottom: "30px", overflow: "unset" }}>
                            <CardContent sx={{ padding: "32px 41px 50px!important", position: "relative" }}>
                                <Grid container >
                                    <Grid xs={12} item display="flex" alignItems="center" sx={{ width: "100%" }} justifyContent="space-between">
                                        <Grid xs={8} display="flex" flexDirection="column">
                                            <Typography fontSize={16} lineHeight="20px" fontWeight={400} color="#A6A6A6" variant="label" pb={1}>
                                                {t('evaluation.item')}
                                            </Typography>
                                            <Typography pr="30px" fontWeight={600} fontSize={20} lineHeight="30px" color="primary" dangerouslySetInnerHTML={{ __html: Util.formatData(item?.name, "-") }}>
                                            </Typography>
                                        </Grid>
                                        <Grid xs={2} display="flex" flexDirection="column">
                                            <Typography fontSize={16} lineHeight="20px" fontWeight={400} color="#A6A6A6" variant="label">
                                                {t('evaluation.weight')}
                                            </Typography>
                                            <Typography fontSize={18} lineHeight="27px" fontWeight={400} pt={1}>
                                                {Util.formatData(item?.weight, "-")}%
                                            </Typography>
                                        </Grid>
                                        <Grid xs={2} display="flex" flexDirection="column">
                                            <Typography fontSize={16} lineHeight="20px" fontWeight={400} color="#A6A6A6" variant="label">
                                                {t('evaluation.expectedRating')}
                                            </Typography>
                                            <Box sx={{ display: "flex", 'align-items': "center", }} pt={1}>
                                                <StyledRatingEva sx={{ root: styles.emptyStar, fontSize: "20px" }} readOnly name="customized-10" precision={0.5} defaultValue={checkDataRating(Util.formatData(item?.expected_rating?.level, false) !== false ? Util.formatData(item?.expected_rating?.level, 0) : 0)} max={1} />
                                                <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400">
                                                    {Util.formatData(item?.expected_rating?.level, false) !== false ? Util.formatData(item?.expected_rating?.level, 0) : "-"}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} pt={3} item display="flex" sx={{ width: "100%" }}>
                                        <Grid xs={have_self_evaluation === false ? 12 : 6} display="flex" alignItems="flex-start">
                                            <Grid xs={12} display="flex" flexDirection="column">
                                                <Box sx={{ display: "flex" }}>
                                                    <Typography fontSize={16} lineHeight="21px" mr="10px" fontWeight={400} color="#A6A6A6" variant="label">
                                                        {t('evaluation.evaluatorRating')}
                                                    </Typography>
                                                    <Box sx={{ position: "relative", cursor: "pointer" }}>
                                                        <div style={{ width: "max-content" }}>
                                                            <BootstrapTooltip
                                                                PopperProps={{
                                                                    disablePortal: true,
                                                                }}
                                                                // style={{ width: "max-content" }}
                                                                onClose={e => handleTooltipOpen(item?.serial + t('evaluation.evaluatorRating'))}
                                                                open={open === true && valueSerial === item?.serial + t('evaluation.evaluatorRating') ? true : false}
                                                                placement="right"
                                                                arrow
                                                                // disableFocusListener
                                                                // disableHoverListener
                                                                // disableTouchListener
                                                                title={t('evaluation.tooltipEvaluator')}
                                                            >
                                                                <TooltipIcon />
                                                            </BootstrapTooltip>
                                                            <div className='tooltip' onClick={e => handleTooltipOpen(item?.serial + t('evaluation.evaluatorRating'))} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                                        </div>
                                                    </Box>
                                                </Box>
                                                {statusEdit ?
                                                    <Box xs md lg={6} sx={{ display: "flex", width: "100%" }} mt="10px">
                                                        <Box xs md lg={4} sx={{ width: "33.33%", }}>
                                                            <Typography fontSize={18} lineHeight="27px" fontWeight={"500"} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                {t('evaluation.overall')}
                                                            </Typography>
                                                        </Box>
                                                        <Box xs md lg={8} display="flex" flexDirection="column" sx={{
                                                            width: "66.66%",
                                                            ".MuiFormHelperText-root": {
                                                                color: " #CC6058 !important",
                                                                fontSize: "14px",
                                                                lineHeight: "15.4px",
                                                                // marginLeft: 0,
                                                                // position: "absolute",
                                                                // bottom: "-22px",
                                                            }
                                                        }}>
                                                            <Box
                                                                display="flex"
                                                                alignItems="flex-start"
                                                                justifyContent="flex-start"
                                                                flexDirection="row"
                                                                pr="20px"
                                                                sx={{
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                <Select
                                                                    id="evaluation-select"
                                                                    inputlabelprops={{ shrink: false }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    defaultValue=""
                                                                    displayEmpty
                                                                    className="white-bg"
                                                                    value={item?.evaluate_rating?.evaluator?.rating?.serial}
                                                                    MenuProps={{ autoFocus: false, sx: { ".MuiPaper-root": { maxWidth: "calc(100% - 56.43%)" } } }}
                                                                    onChange={e => handleChangeRating(e, order, "custom_template_item", "evaluator", item?.serial)}
                                                                    sx={actSave && Util.formatData(item?.evaluate_rating?.evaluator?.rating?.serial, false) === false ? { ".MuiOutlinedInput-notchedOutline": { "border-color": "#CC6058!important" }, } : {}}
                                                                >
                                                                    <MenuItem disabled value="" sx={{ display: "none" }}>
                                                                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#C4C4C4", fontSize: "16px", fontWeight: "300", lineHeight: "23.92px" }}>{t('evaluation.notEvaluatedYet')}</span>
                                                                    </MenuItem>
                                                                    {
                                                                        item?.custom_template_scale?.length > 0 ?
                                                                            item?.custom_template_scale.map(itemMap => {
                                                                                return (
                                                                                    <MenuItem value={itemMap.serial} key={itemMap.serial}>
                                                                                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{itemMap.level} - {getName(itemMap?.description)}</span>
                                                                                    </MenuItem>
                                                                                )
                                                                            })

                                                                            : <MenuItem value="">
                                                                                ---{t('label.notFund')}---
                                                                            </MenuItem>
                                                                    }
                                                                </Select>
                                                            </Box>
                                                            {actSave && Util.formatData(item?.evaluate_rating?.evaluator?.rating?.serial, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px", color: "#CC6058!important" }}>Please select this field. </FormHelperText>) : <></>}
                                                        </Box>
                                                    </Box>
                                                    : Util.formatData(item?.evaluate_rating?.evaluator?.rating?.serial, false) !== false ?
                                                        <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                            <Box xs md lg={4} sx={{ width: "33.33%", }}>
                                                                <Typography fontSize={18} lineHeight="27px" fontWeight={"500"} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                    {t('evaluation.overall')}
                                                                </Typography>
                                                            </Box>
                                                            <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                <RatingEvaluation fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={checkDataRating(Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, 0))} max={Number(item?.scale_level_min_max?.max)} />
                                                                {Util.formatData(item?.evaluate_rating?.evaluator?.rating?.description, false) !== false ?
                                                                    <BootstrapTooltip
                                                                        PopperProps={{
                                                                            disablePortal: true,
                                                                        }}
                                                                        placement="top"
                                                                        arrow
                                                                        // title={`${dt?.evaluator?.rating?.value} - ${dt?.evaluator?.rating?.description}`}
                                                                        title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, "-") + "-" + Util.formatData(item?.evaluate_rating?.evaluator?.rating?.description, "-") }} />}
                                                                    >
                                                                        <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={1} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                            {item?.evaluate_rating?.evaluator?.rating?.value} - {getName(item?.evaluate_rating?.evaluator?.rating?.description)}
                                                                        </Typography>
                                                                    </BootstrapTooltip>
                                                                    : Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, false) !== false ?
                                                                        <BootstrapTooltip
                                                                            PopperProps={{
                                                                                disablePortal: true,
                                                                            }}
                                                                            placement="top"
                                                                            arrow
                                                                            // title={`${dt?.evaluator?.rating?.value}`}
                                                                            title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, "-") }} />}
                                                                        >
                                                                            <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={4} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                {item?.evaluate_rating?.evaluator?.rating?.value}
                                                                            </Typography>
                                                                        </BootstrapTooltip>
                                                                        :
                                                                        <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" mt="10px">

                                                                        </Typography>
                                                                }
                                                            </Box>
                                                        </Box>
                                                        :
                                                        <Box sx={{ display: "flex", width: "100%" }} mt="10px">
                                                            <Box sx={{ width: "33.33%", }}>
                                                                <Typography fontSize={18} lineHeight="27px" fontWeight={"500"} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                    {t('evaluation.overall')}
                                                                </Typography>
                                                            </Box>
                                                            <Box display="flex" sx={{ width: "66.66%" }}>
                                                                <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400}  >
                                                                    {loRow?.allow_evaluate === false ? t('evaluation.pending') + "..." : t('evaluation.notEvaluatedYet')}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} pt={3} item display="flex" sx={{ width: "100%" }} justifyContent="space-between">
                                        <Grid xs={12} display="flex" >
                                            <Grid xs={12} display="flex" flexDirection="column" pr="20px">

                                                <Box sx={{ display: "flex" }}>
                                                    <Typography fontSize={16} lineHeight="21px" fontWeight={400} color="#A6A6A6" variant="label">
                                                        {t('evaluation.evaluatorComment')}
                                                    </Typography>

                                                </Box>
                                                {statusEdit ?
                                                    <Grid
                                                        item
                                                        mt="10px"
                                                        xs={12}
                                                        sx={{
                                                            ".MuiFormHelperText-root": {
                                                                color: " #CC6058 !important",
                                                                fontSize: "14px",
                                                                lineHeight: "15.4px",
                                                                // marginLeft: 0,
                                                                // position: "absolute",
                                                                // bottom: "-22px",
                                                            },
                                                            ".MuiOutlinedInput-notchedOutline": {
                                                                "border-color": actSave && loRow?.require_evaluator_comment && Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) === false ? "#CC6058 !important" : ""
                                                            },
                                                            ".MuiOutlinedInput-root": {
                                                                padding: "8.5px 14px",
                                                                ".MuiInputBase-input": {
                                                                    padding: "0"
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <TextField
                                                            fullWidth
                                                            name="evaluator_comment"
                                                            placeholder={t('evaluation.enterYourEvaluatorComment')}
                                                            onChange={e => handleChangeComment(e, order, "custom_template_item", "evaluator", item?.serial)}
                                                            value={item?.evaluate_rating?.evaluator?.comment}
                                                            variant="outlined"
                                                            inputProps={{
                                                                sx: {
                                                                    "&::placeholder": {
                                                                        opacity: "1",
                                                                        color: "#C4C4C4",
                                                                        fontWeight: "300",
                                                                    }
                                                                }
                                                            }}
                                                            // multiline
                                                            // rows={3}
                                                            helperText={actSave && loRow?.require_evaluator_comment && Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) === false ? t('evaluation.pleaseSelectThisField') : ""}
                                                            error={actSave && loRow?.require_evaluator_comment && Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) === false}
                                                        />
                                                    </Grid>
                                                    :
                                                    <Typography sx={{ wordBreak: "break-all" }} fontSize={18} lineHeight="27px" mt="10px" color={Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) !== false ? "#404349" : "#C4C4C4"} fontWeight={400} >
                                                        {Util.formatData(item?.evaluate_rating?.evaluator?.comment, loRow?.allow_evaluate === false ? "-" : t('evaluation.notEvaluatedYet'))}
                                                    </Typography>
                                                }
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    ))}
                </Grid>
                :
                //competency_items            
                Util.formatData(data?.competency_items, false) !== false && data?.competency_items.length > 0 ?
                    <Box item xs={12} >
                        {data?.competency_items.map((item, order) => (
                            <Card sx={{ height: 1, marginBottom: "30px", overflow: "unset" }}>
                                <CardContent sx={{ padding: "32px 41px 50px!important", position: "relative" }}>
                                    <Box container>
                                        <Box xs={12} item display="flex" alignItems="center" sx={{ width: "100%" }} justifyContent="space-between">
                                            <Grid xs={6} display="flex" flexDirection="column" >
                                                <Typography fontSize={16} color="#A6A6A6" mr="10px" lineHeight="20px" fontWeight={400} variant="label" pb={1}>
                                                    {t('evaluation.competency')}
                                                </Typography>
                                                <BootstrapTooltip title={Util.formatData(item?.name, "-")} placement="top">
                                                    <Typography fontWeight={600} sx={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", transition: "ease 300ms", "&:hover": { color: "#5DA196", textDecoration: "underline", transition: "ease 300ms" } }} onClick={e => onOpenCompetency(item?.name, item?.proficiency, item?.description, item?.competency_scale)} fontSize={20} lineHeight="30px" color="primary">
                                                        {Util.formatData(item?.name, "-")}
                                                    </Typography>
                                                </BootstrapTooltip>
                                            </Grid>
                                            <Grid xs={2} display="flex" flexDirection="column">
                                                <Typography fontSize={16} lineHeight="20px" fontWeight={400} color="#A6A6A6" variant="label">
                                                    {t('evaluation.expectedRating')}
                                                </Typography>
                                                <Box sx={{ display: "flex", 'align-items': "center", }} pt={1}>
                                                    <StyledRatingEva sx={{ root: styles.emptyStar, fontSize: "20px" }} readOnly name="customized-10" precision={0.5} defaultValue={checkDataRating(Util.formatData(item?.expected_rating?.level, 0))} max={1} />
                                                    <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400">
                                                        {Util.formatData(item?.expected_rating?.level, "-")}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid xs={4} display="flex" flexDirection="column" alignItems="flex-end">
                                                <Box className={`${classes.containerAchievements}`} onClick={e => onOpenAchievements(loRow.type, item.serial, formID)} style={{ cursor: "pointer" }}>
                                                    <Box sx={{ padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                        <Typography fontSize={18} lineHeight="26.91px" >
                                                            {/* <Typography fontSize={18} lineHeight="26.91px" pr="20px" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}> */}
                                                            {t('evaluation.supportedAchievements')}: <span style={{ color: "#5DA196" }}>{Util.formatData(item?.achievement_count, "-")}</span>
                                                        </Typography>
                                                        <BootstrapTooltip title={t('evaluation.viewAchievements')} placement="top">
                                                            <KpiArrow />
                                                        </BootstrapTooltip>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Box>
                                        <Box xs={12} pt={3} item display="flex" alignItems="center" sx={{ width: "100%" }} justifyContent="space-between">
                                            <Box xs={4} display="flex" flexDirection="column">
                                                <Typography fontSize={16} lineHeight="20px" fontWeight={400} color="#A6A6A6" variant="label">
                                                    {t('evaluation.proficiency')}
                                                </Typography>
                                                <Typography fontSize={18} lineHeight="27px" fontWeight={400} pt={1}>
                                                    {item?.proficiency?.level !== undefined && item?.proficiency?.level !== "" && item?.proficiency?.description !== undefined && item?.proficiency?.description !== "" ?
                                                        `Level ${Util.formatData(item?.proficiency?.level, "-")} - ${Util.formatData(item?.proficiency?.description, "-")}` :
                                                        "-"}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box xs={12} pt={3} item display="flex" sx={{ width: "100%" }}>
                                            <Box display="flex" alignItems="flex-start" sx={{ width: "100%" }}>
                                                <Box xs={12} display="flex" flexDirection="column" sx={{ width: "100%" }}>
                                                    <Box sx={{ display: "flex" }}>
                                                        <Typography fontSize={16} lineHeight="20px" fontWeight={400} mr="10px" color="#A6A6A6" variant="label">
                                                            {t('evaluation.evaluatorRating')}
                                                        </Typography>
                                                        <Box sx={{ position: "relative", cursor: "pointer" }}>
                                                            <div style={{ width: "max-content" }}>
                                                                <BootstrapTooltip
                                                                    PopperProps={{
                                                                        disablePortal: true,
                                                                    }}
                                                                    // style={{ width: "max-content" }}
                                                                    onClose={e => handleTooltipOpen(item?.serial + t('evaluation.evaluatorRating'))}
                                                                    open={open === true && valueSerial === item?.serial + t('evaluation.evaluatorRating') ? true : false}
                                                                    placement="right"
                                                                    arrow
                                                                    // disableFocusListener
                                                                    // disableHoverListener
                                                                    // disableTouchListener
                                                                    title={t('evaluation.tooltipEvaluator')}
                                                                >
                                                                    <TooltipIcon />
                                                                </BootstrapTooltip>
                                                                <div className='tooltip' onClick={e => handleTooltipOpen(item?.serial + t('evaluation.evaluatorRating'))} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div>
                                                            </div>
                                                        </Box>
                                                    </Box>
                                                    {item?.competency_behavioral !== undefined && item?.competency_behavioral.length > 0 ?
                                                        item?.competency_behavioral.map((result, id) => (
                                                            statusEdit ?
                                                                <Box>
                                                                    {id === 0 ?
                                                                        <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                            <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                                <Typography fontSize={18} lineHeight="27px" fontWeight={500} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                    {t('evaluation.overall')}
                                                                                </Typography>
                                                                            </Box>
                                                                            <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                                <RatingEvaluation fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={checkDataRating(sunBehavioral(item?.competency_behavioral, "evaluator",))} max={Number(item?.scale_level_min_max?.max)} />
                                                                                <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={1} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                    {sunBehavioral(item?.competency_behavioral, "evaluator",)}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                        : null
                                                                    }
                                                                    <Box xs md lg={6} sx={{ display: "flex", width: "100%" }} mt="10px">
                                                                        <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                            <BootstrapTooltip
                                                                                PopperProps={{
                                                                                    disablePortal: true,
                                                                                }}
                                                                                placement="top"
                                                                                arrow
                                                                                // title={`${item?.evaluate_rating?.evaluator?.rating?.value} - ${item?.evaluate_rating?.evaluator?.rating?.description}`}
                                                                                title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(result?.name, "-") }} />}
                                                                            >
                                                                                <Typography fontSize={18} lineHeight="27px" fontWeight={400} sx={{ cursor: "pointer", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                    {result?.name}
                                                                                </Typography>
                                                                            </BootstrapTooltip>
                                                                        </Box>
                                                                        <Box xs md lg={8} display="flex" sx={{
                                                                            width: "66.66%",
                                                                            ".MuiFormHelperText-root": {
                                                                                color: " #CC6058 !important",
                                                                                fontSize: "14px",
                                                                                lineHeight: "15.4px",
                                                                                // marginLeft: 0,
                                                                                // position: "absolute",
                                                                                // bottom: "-22px",
                                                                            }
                                                                        }}>
                                                                            {/* {ratingSelect.length > 0 ? */}
                                                                            <Box
                                                                                display="flex"
                                                                                alignItems="flex-start"
                                                                                justifyContent="flex-start"
                                                                                flexDirection="column"
                                                                                pr="20px"
                                                                                sx={{
                                                                                    width: "100%",
                                                                                }}
                                                                            >
                                                                                <Select
                                                                                    id="evaluation-select"
                                                                                    inputlabelprops={{ shrink: false }}
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    fullWidth
                                                                                    defaultValue=""
                                                                                    displayEmpty
                                                                                    className="white-bg"
                                                                                    value={item?.competency_behavioral[id]?.evaluate_rating?.evaluator?.rating?.serial}
                                                                                    MenuProps={{ autoFocus: false, sx: { ".MuiPaper-root": { maxWidth: "calc(100% - 71.43%)" } } }}
                                                                                    onChange={e => handleChangeRating(e, order, "competency_items", "evaluator", item?.serial, result?.serial, id, "behavioral")}
                                                                                    sx={actSave && Util.formatData(item?.competency_behavioral[id]?.evaluate_rating?.evaluator?.rating?.serial, false) === false ? { ".MuiOutlinedInput-notchedOutline": { "border-color": "#CC6058!important" } } : {}}
                                                                                >
                                                                                    <MenuItem disabled value="" sx={{ display: "none" }}>
                                                                                        <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t('evaluation.notEvaluatedYet')} </Typography>
                                                                                    </MenuItem>
                                                                                    {
                                                                                        result.behavioral_scale?.length !== undefined && result.behavioral_scale?.length > 0 ?
                                                                                            result.behavioral_scale.map(item => {
                                                                                                return (
                                                                                                    <MenuItem value={item.serial} key={item.serial}>
                                                                                                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{item.level} - {getName(item?.description)}</span>
                                                                                                    </MenuItem>
                                                                                                )
                                                                                            })

                                                                                            : <MenuItem value="">
                                                                                                ---{t('label.notFund')}---
                                                                                            </MenuItem>
                                                                                    }
                                                                                </Select>
                                                                            </Box>
                                                                            {/* : null} */}
                                                                            {actSave && Util.formatData(item?.competency_behavioral[id]?.evaluate_rating?.evaluator?.rating?.serial, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px", color: "#CC6058!important" }}>{t('evaluation.pleaseSelectThisField')}</FormHelperText>) : <></>}
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                                : Util.formatData(result?.evaluate_rating?.evaluator?.rating?.serial, false) !== false ?
                                                                    <Box>
                                                                        {id === 0 ?
                                                                            <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                                <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                                    <Typography fontSize={18} lineHeight="27px" fontWeight={500} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                        {t('evaluation.overall')}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                                    <RatingEvaluation fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={checkDataRating(Util.formatData(result?.evaluate_rating?.evaluator?.rating?.value, 0))} max={Number(item?.scale_level_min_max?.max)} />
                                                                                    {item?.evaluate_rating?.evaluator?.rating?.description !== "" && item?.evaluate_rating?.evaluator?.rating?.description !== null && item?.evaluate_rating?.evaluator?.rating?.description !== undefined ?
                                                                                        <BootstrapTooltip
                                                                                            PopperProps={{
                                                                                                disablePortal: true,
                                                                                            }}
                                                                                            placement="top"
                                                                                            arrow
                                                                                            // title={`${item?.evaluate_rating?.evaluator?.rating?.value} - ${item?.evaluate_rating?.evaluator?.rating?.description}`}
                                                                                            title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, "-") + "-" + Util.formatData(item?.evaluate_rating?.evaluator?.rating?.description, "-") }} />}
                                                                                        >
                                                                                            <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={1} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                                {item?.evaluate_rating?.evaluator?.rating?.value} - {getName(item?.evaluate_rating?.evaluator?.rating?.description)}
                                                                                            </Typography>
                                                                                        </BootstrapTooltip>
                                                                                        : Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, false) !== false ?
                                                                                            <BootstrapTooltip
                                                                                                PopperProps={{
                                                                                                    disablePortal: true,
                                                                                                }}
                                                                                                placement="top"
                                                                                                arrow
                                                                                                // title={`${item?.evaluate_rating?.evaluator?.rating?.value}`}
                                                                                                title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, "-") }} />}
                                                                                            >
                                                                                                <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={1} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                                    {item?.evaluate_rating?.evaluator?.rating?.value}
                                                                                                </Typography>
                                                                                            </BootstrapTooltip>
                                                                                            :
                                                                                            <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" mt="10px">

                                                                                            </Typography>
                                                                                    }
                                                                                </Box>
                                                                            </Box>
                                                                            : null
                                                                        }
                                                                        <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                            <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                                <BootstrapTooltip
                                                                                    PopperProps={{
                                                                                        disablePortal: true,
                                                                                    }}
                                                                                    placement="top"
                                                                                    arrow
                                                                                    // title={`${item?.evaluate_rating?.evaluator?.rating?.value} - ${item?.evaluate_rating?.evaluator?.rating?.description}`}
                                                                                    title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(result?.name, "-") }} />}
                                                                                >
                                                                                    <Typography fontSize={18} lineHeight="27px" fontWeight={result?.name === "Overall" ? "500" : "400"} sx={{ cursor: "pointer", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                        {result?.name}
                                                                                    </Typography>
                                                                                </BootstrapTooltip>
                                                                            </Box>
                                                                            <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                                <RatingEvaluation fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={checkDataRating(Util.formatData(result?.evaluate_rating?.evaluator?.rating?.value, 0))} max={Number(item?.scale_level_min_max?.max)} />
                                                                                {result?.evaluate_rating?.evaluator?.rating?.description !== "" && result?.evaluate_rating?.evaluator?.rating?.description !== null && result?.evaluate_rating?.evaluator?.rating?.description !== undefined ?
                                                                                    <BootstrapTooltip
                                                                                        PopperProps={{
                                                                                            disablePortal: true,
                                                                                        }}
                                                                                        placement="top"
                                                                                        arrow
                                                                                        // title={`${result?.evaluate_rating?.evaluator?.rating?.value} - ${result?.evaluate_rating?.evaluator?.rating?.description}`}
                                                                                        title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(result?.evaluate_rating?.evaluator?.rating?.value, "-") + "-" + Util.formatData(result?.evaluate_rating?.evaluator?.rating?.description, "-") }} />}
                                                                                    >
                                                                                        <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={1} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                            {result?.evaluate_rating?.evaluator?.rating?.value} - {getName(result?.evaluate_rating?.evaluator?.rating?.description)}
                                                                                        </Typography>
                                                                                    </BootstrapTooltip>
                                                                                    : Util.formatData(result?.evaluate_rating?.evaluator?.rating?.value, false) !== false ?
                                                                                        <BootstrapTooltip
                                                                                            PopperProps={{
                                                                                                disablePortal: true,
                                                                                            }}
                                                                                            placement="top"
                                                                                            arrow
                                                                                            // title={`${result?.evaluate_rating?.evaluator?.rating?.value}`}
                                                                                            title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(result?.evaluate_rating?.evaluator?.rating?.value, "-") }} />}
                                                                                        >
                                                                                            <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={4} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                                {result?.evaluate_rating?.evaluator?.rating?.value}
                                                                                            </Typography>
                                                                                        </BootstrapTooltip>
                                                                                        :
                                                                                        <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" mt="10px">

                                                                                        </Typography>
                                                                                }
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                    :
                                                                    <Box>
                                                                        {id === 0 ?
                                                                            <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                                <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                                    <Typography fontSize={18} lineHeight="27px" fontWeight={500} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                        {t('evaluation.overall')}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                                    <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                                        {t('evaluation.notEvaluatedYet')}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            : null
                                                                        }
                                                                        <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                            <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                                <BootstrapTooltip
                                                                                    PopperProps={{
                                                                                        disablePortal: true,
                                                                                    }}
                                                                                    placement="top"
                                                                                    arrow
                                                                                    // title={`${item?.evaluate_rating?.evaluator?.rating?.value} - ${item?.evaluate_rating?.evaluator?.rating?.description}`}
                                                                                    title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(result?.name, "-") }} />}
                                                                                >
                                                                                    <Typography fontSize={18} lineHeight="27px" fontWeight={result?.name === "Overall" ? "500" : "400"} sx={{ cursor: "pointer", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                        {result?.name}
                                                                                    </Typography>
                                                                                </BootstrapTooltip>
                                                                            </Box>
                                                                            <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                                <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                                    {t('evaluation.notEvaluatedYet')}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>

                                                        ))
                                                        : item?.competency_behavioral !== undefined || item?.competency_behavioral.length === 0 ?
                                                            statusEdit ?
                                                                <Box xs md lg={6} sx={{ display: "flex", width: "100%" }} mt="10px">
                                                                    <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                        <Typography fontSize={18} lineHeight="27px" fontWeight={"500"} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                            {t('evaluation.overall')}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box xs md lg={8} display="flex" flexDirection="column" sx={{
                                                                        width: "66.66%",
                                                                        ".MuiFormHelperText-root": {
                                                                            color: " #CC6058 !important",
                                                                            fontSize: "14px",
                                                                            lineHeight: "15.4px",
                                                                            // marginLeft: 0,
                                                                            // position: "absolute",
                                                                            // bottom: "-22px",
                                                                        }
                                                                    }}>
                                                                        {/* {ratingSelect.length > 0 ? */}
                                                                        <Box
                                                                            display="flex"
                                                                            alignItems="flex-start"
                                                                            justifyContent="flex-start"
                                                                            flexDirection="column"
                                                                            pr="20px"
                                                                            sx={{
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <Select
                                                                                id="evaluation-select"
                                                                                inputlabelprops={{ shrink: false }}
                                                                                variant="outlined"
                                                                                size="small"
                                                                                fullWidth
                                                                                defaultValue=""
                                                                                displayEmpty
                                                                                className="white-bg"
                                                                                value={item?.evaluate_rating?.evaluator?.rating?.serial}
                                                                                MenuProps={{ autoFocus: false, sx: { ".MuiPaper-root": { maxWidth: "calc(100% - 71.43%)" } } }}
                                                                                onChange={e => handleChangeRating(e, order, "competency_items", "evaluator", item?.serial)}
                                                                                sx={actSave && Util.formatData(item?.evaluate_rating?.evaluator?.rating?.serial, false) === false ? { ".MuiOutlinedInput-notchedOutline": { "border-color": "#CC6058!important" } } : {}}
                                                                            >
                                                                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                                                                    <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t('evaluation.notEvaluatedYet')} </Typography>
                                                                                </MenuItem>
                                                                                {
                                                                                    item?.competency_scale?.length > 0 ?
                                                                                        item?.competency_scale.map(itemMap => {
                                                                                            return (
                                                                                                <MenuItem value={itemMap.serial} key={itemMap.serial}>
                                                                                                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{itemMap.level} - {getName(itemMap?.description)}</span>
                                                                                                </MenuItem>
                                                                                            )
                                                                                        })

                                                                                        : <MenuItem value="">
                                                                                            ---{t('label.notFund')}---
                                                                                        </MenuItem>
                                                                                }
                                                                            </Select>
                                                                        </Box>
                                                                        {/* : null} */}
                                                                        {actSave && Util.formatData(item?.evaluate_rating?.evaluator?.rating?.serial, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px", color: "#CC6058!important" }}>{t('evaluation.pleaseSelectThisField')}</FormHelperText>) : <></>}
                                                                    </Box>
                                                                </Box>
                                                                : Util.formatData(item?.evaluate_rating?.evaluator?.rating?.serial, false) !== false ?
                                                                    <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                        <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                            <Typography fontSize={18} lineHeight="27px" fontWeight={"500"} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                {t('evaluation.overall')}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                            <RatingEvaluation fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={checkDataRating(Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, 0))} max={Number(item?.scale_level_min_max?.max)} />
                                                                            {Util.formatData(item?.evaluate_rating?.evaluator?.rating?.description, false) !== false ?
                                                                                <BootstrapTooltip
                                                                                    PopperProps={{
                                                                                        disablePortal: true,
                                                                                    }}
                                                                                    placement="top"
                                                                                    arrow
                                                                                    // title={`${item?.evaluate_rating?.evaluator?.rating?.value} - ${item?.evaluate_rating?.evaluator?.rating?.description}`}
                                                                                    title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, "-") + "-" + Util.formatData(item?.evaluate_rating?.evaluator?.rating?.description, "-") }} />}
                                                                                >
                                                                                    <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={1} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                        {item?.evaluate_rating?.evaluator?.rating?.value} - {getName(item?.evaluate_rating?.evaluator?.rating?.description)}
                                                                                    </Typography>
                                                                                </BootstrapTooltip>
                                                                                : Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, false) !== false ?
                                                                                    <BootstrapTooltip
                                                                                        PopperProps={{
                                                                                            disablePortal: true,
                                                                                        }}
                                                                                        placement="top"
                                                                                        arrow
                                                                                        // title={`${item?.evaluate_rating?.evaluator?.rating?.value}`}
                                                                                        title={<Typography fontSize={14} fontWeight="400" dangerouslySetInnerHTML={{ __html: Util.formatData(item?.evaluate_rating?.evaluator?.rating?.value, "-") }} />}
                                                                                    >
                                                                                        <Typography fontSize={18} lineHeight="27px" color="#404349" fontWeight="400" ml={4} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                            {item?.evaluate_rating?.evaluator?.rating?.value}
                                                                                        </Typography>
                                                                                    </BootstrapTooltip>
                                                                                    :
                                                                                    <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" mt="10px">

                                                                                    </Typography>
                                                                            }
                                                                        </Box>
                                                                    </Box>
                                                                    :
                                                                    <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                        <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                            <Typography fontSize={18} lineHeight="27px" fontWeight={500} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                                {t('evaluation.overall')}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                            <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                                {t('evaluation.notEvaluatedYet')}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                            :
                                                            <Box xs md lg={6} sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="10px">
                                                                <Box xs md lg={4} sx={{ width: "33.33%" }}>
                                                                    <Typography fontSize={18} lineHeight="27px" fontWeight={500} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} pr="20px">
                                                                        {t('evaluation.overall')}
                                                                    </Typography>
                                                                </Box>
                                                                <Box xs md lg={8} display="flex" sx={{ width: "66.66%" }}>
                                                                    <Typography fontSize={18} lineHeight="27px" color="#C4C4C4" fontWeight={400} variant="sub_label" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                        {t('evaluation.notEvaluatedYet')}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                    }
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box xs={12} pt={3} item display="flex" sx={{ width: "100%" }} justifyContent="space-between">
                                            <Box display="flex" sx={{ width: "100%" }}  >
                                                <Box xs={12} display="flex" flexDirection="column" sx={{ width: "100%" }} pr="20px">
                                                    <Box sx={{ display: "flex" }}>
                                                        <Typography fontSize={16} lineHeight="21px" fontWeight={400} color="#A6A6A6" variant="label">
                                                            {t('evaluation.evaluatorComment')}
                                                        </Typography>

                                                    </Box>
                                                    {statusEdit ?
                                                        <Box
                                                            item
                                                            mt="10px"
                                                            xs={10}
                                                            sx={{
                                                                ".MuiFormHelperText-root": {
                                                                    color: " #CC6058 !important",
                                                                    fontSize: "14px",
                                                                    lineHeight: "15.4px",
                                                                    // marginLeft: 0,
                                                                    // position: "absolute",
                                                                    // bottom: "-22px",
                                                                },
                                                                ".MuiOutlinedInput-notchedOutline": {
                                                                    "border-color": actSave && loRow?.require_evaluator_comment && Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) === false ? "#CC6058 !important" : ""
                                                                },
                                                                ".MuiOutlinedInput-root": {
                                                                    padding: "8.5px 14px",
                                                                    ".MuiInputBase-input": {
                                                                        padding: "0"
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <TextField
                                                                fullWidth
                                                                name="evaluator_comment"
                                                                placeholder={t('evaluation.enterYourEvaluatorComment')}
                                                                onChange={e => handleChangeComment(e, order, "competency_items", "evaluator", item?.serial)}
                                                                value={item?.evaluate_rating?.evaluator?.comment}
                                                                variant="outlined"
                                                                inputProps={{
                                                                    sx: {
                                                                        "&::placeholder": {
                                                                            opacity: "1",
                                                                            color: "#C4C4C4",
                                                                            fontWeight: "300",
                                                                        }
                                                                    }
                                                                }}
                                                                // multiline
                                                                // rows={3}
                                                                helperText={actSave && loRow?.require_evaluator_comment && Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) === false ? t('evaluation.pleaseSelectThisField') : ""}
                                                                error={actSave && loRow?.require_evaluator_comment && Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) === false}
                                                            />
                                                        </Box>
                                                        :
                                                        <Typography sx={{ wordBreak: "break-all" }} fontSize={18} lineHeight="27px" mt="10px" color={Util.formatData(item?.evaluate_rating?.evaluator?.comment, false) !== false ? "#404349" : "#C4C4C4"} fontWeight={400} >
                                                            {Util.formatData(item?.evaluate_rating?.evaluator?.comment, t('evaluation.notCommentedYet'))}
                                                        </Typography>
                                                    }
                                                </Box>

                                            </Box>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                    :
                    <Box item sx={styles.emty} >
                        <img src={emty} alt="emtyData"></img>
                        <Typography pt={1} fontSize={16} fontWeight="fontWeightLight" variant="label">
                            {Util.formatData(data?.goal_items, false) !== false && data?.goal_items.length < 1 ?
                                t('evaluation.emtyGoal')
                                : Util.formatData(data?.competency_items, false) !== false && data?.competency_items.length < 1 ?
                                    t('evaluation.emtyCompetency')
                                    : "Your evaluation has not been assigned yet."
                            }
                        </Typography>
                    </Box>
            }
            <DialogAchievements open={openAchievements} close={onCloseAchievements} data={dataAchievements} type={type} />
            <DialogGoal data={dataGoal} open={openGoal} close={onCloseGoal} />
            <SimpleDialog
                open={isSuccessRequest}
                setValue={closeRequestSuccess}
                text={t('feedback.label.requestFeedbackWasSent')}
                subTitle=""
            />
            <DialogRequest open={openRequest} close={onCloseRequest} openSuccessAddDialog={onCloseRequestSuccess} dataOwner={dataEmpolyee} dataEmpolyeeOwner={dataEmpolyeeOwner} type={typeRequest} typeList={type} page={"evaluation"} refID={refID} datas={type === 'goal' ? dataGoalRequest : dataCompetencyRequest} />
            <DialogViewFeedback openRequest={openDialogRequest} open={openViewFeedback} close={closeViewFeedback} dataViewFeedback={dataViewFeedback} />
            <DialogCompetency name={nameCompetency} proficiency={proficiencyCompetency} description={descriptionCompetency} scale={scale} open={openCompetency} close={onCloseCompetency} data />
        </Box >
    );
};
export default SeeAllCompetency;
